import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('app.WorkflowIdPage.SectionTerms', {
    title: 'Terms',
    subtitle:
        'Terms refer to the specific conditions, agreements, and requirements that govern a particular transaction or agreement',
    placeholder: 'Enter terms',
});
